import { useState, useMemo } from "react";
import axios from "axios";
import { toast } from "sonner";
import { API_URL } from "@/utils/apiConfig";

const API = `${API_URL}/api/v1`;

export function usePlatformAdminAuth() {
  const [adminToken, setAdminToken] = useState(
    () => localStorage.getItem("platform_admin_token") || ""
  );
  const [adminUser, setAdminUser] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("platform_admin_user") || "null");
    } catch {
      return null;
    }
  });
  const [loginEmail, setLoginEmail] = useState("");
  const [loginPassword, setLoginPassword] = useState("");
  const [loginLoading, setLoginLoading] = useState(false);

  const adminAxios = useMemo(() => {
    const instance = axios.create({ baseURL: API });
    instance.interceptors.request.use((cfg) => {
      const t = localStorage.getItem("platform_admin_token");
      if (t) cfg.headers.Authorization = `Bearer ${t}`;
      return cfg;
    });
    instance.interceptors.response.use(
      (response) => {
        const d = response.data;
        if (d && typeof d === "object" && d.success === true && "data" in d) {
          response.data = d.data;
        }
        return response;
      },
      (error) => {
        // Token expired or invalid — force re-login so admin doesn't see silent empty data
        if (error.response?.status === 401) {
          localStorage.removeItem("platform_admin_token");
          localStorage.removeItem("platform_admin_user");
          window.location.reload();
          return new Promise(() => {});
        }
        const d = error.response?.data;
        if (d && d.success === false && d.error) {
          error.response.data.detail = d.error.message;
        }
        return Promise.reject(error);
      }
    );
    return instance;
  }, []);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoginLoading(true);
    try {
      const res = await axios.post(`${API}/platform-admin/login`, {
        email: loginEmail,
        password: loginPassword,
      });
      const { access_token, user } = res.data;
      localStorage.setItem("platform_admin_token", access_token);
      localStorage.setItem("platform_admin_user", JSON.stringify(user));
      setAdminToken(access_token);
      setAdminUser(user);
      toast.success(`Bem-vindo, ${user.name || user.email}!`);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Credenciais invalidas");
    }
    setLoginLoading(false);
  };

  const handleLogout = () => {
    localStorage.removeItem("platform_admin_token");
    localStorage.removeItem("platform_admin_user");
    setAdminToken("");
    setAdminUser(null);
  };

  const isAuthenticated = !!(adminToken && adminUser);

  return {
    isAuthenticated,
    adminUser,
    adminAxios,
    loginEmail,
    setLoginEmail,
    loginPassword,
    setLoginPassword,
    loginLoading,
    handleLogin,
    handleLogout,
  };
}
